import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SmoothScroll from "./components/SmoothScroll";
import { SettingsProvider } from "./context/SettingsContext";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Realisations from "./pages/Realisations";
import Entreprise from "./pages/Entreprise";
import Contact from "./pages/Contact";
import Depannage from "./pages/Depannage";
import Entretien from "./pages/Entretien";
import Devis from "./pages/Devis";
import Aides from "./pages/Aides";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import "./App.css";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function Shell() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return <Routes><Route path="/admin" element={<Admin />} /></Routes>;
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/climatisation" element={<ServicePage pageKey="climatisation" />} />
        <Route path="/climatisation/gainable" element={<ServicePage pageKey="gainable" />} />
        <Route path="/pompe-a-chaleur-air-air" element={<ServicePage pageKey="pac" />} />
        <Route path="/froid-commercial" element={<ServicePage pageKey="froid-commercial" />} />
        <Route path="/froid-commercial/chambre-froide" element={<ServicePage pageKey="chambre-froide" />} />
        <Route path="/entretien" element={<Entretien />} />
        <Route path="/depannage" element={<Depannage />} />
        <Route path="/entretien-climatisation" element={<Navigate to="/entretien" replace />} />
        <Route path="/depannage-climatisation-froid" element={<Navigate to="/depannage" replace />} />
        <Route path="/realisations" element={<Realisations />} />
        <Route path="/entreprise" element={<Entreprise />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/demande-de-devis" element={<Devis />} />
        <Route path="/aides" element={<Aides />} />
        <Route path="/mentions-legales" element={<Legal type="mentions" />} />
        <Route path="/politique-de-confidentialite" element={<Legal type="confidentialite" />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </PublicLayout>
  );
}

export default function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Shell />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </SettingsProvider>
  );
}
